import Axios from 'axios';
import { APIBASE_URL, BASIC_INFORMATION_URL } from '../config/cacheKey';
import { IDocumentTypeHints, IGetSupportInfoResponse } from '../models/basicInformation.model';
import { ApiResultModel } from '../models/common.model';

export const GetDocumentTypes = (): Promise<
    IDocumentTypeHints[]
> => {
    return Axios.post<ApiResultModel<IDocumentTypeHints[]>>(
        APIBASE_URL + BASIC_INFORMATION_URL + '/GetDocumentTypes'
    ).then((result) => {
        return result.data.data;
    });
};

export const GetSupportInfo = async (): Promise<IGetSupportInfoResponse[]> => {
    return await Axios.post<ApiResultModel<IGetSupportInfoResponse[]>>(
        APIBASE_URL + BASIC_INFORMATION_URL + '/GetSupportInfo'
    ).then((result) => {
        return result.data.data;
    });
};

export const GetPrivacyStatement = (): Promise<string> => {
    return Axios.get<ApiResultModel<string>>(
        APIBASE_URL + BASIC_INFORMATION_URL + "/GetPrivacyStatement"
    ).then((result) => {
        return result.data.data;
    });
};
